import { getErrorMessage } from '@/Framework/Message/Mapper/getMessage';
import { getValidChangedProducts } from '@/finsight/application/actions/profile/helpers/getValidChangedProducts';
import { isRedirectToDefaultActive } from '@/finsight/application/actions/profile/helpers/isRedirectToDefaultActive';
import { getMetaTagsByFilters } from '@/finsight/application/actions/profile/helpers/getMetaTagsByFilters';
import { reInitProfilePage } from '@/finsight/application/actions/profile/helpers/reInitProfilePage';
import { getBaseProfileFilters } from '@/finsight/application/actions/profile/helpers/getBaseProfileFilters';
import { setPageFilters, resetPageFilters } from '@/finsight/application/actions/pageFilters/actions';
import { AlertManager } from '@dealroadshow/uikit/core/components/Alert';
import { setMetaTags } from '@/finsight/application/actions/metaTags/actions';
import { getDealsTile } from '@/finsight/application/actions/deals/actions';

export const resetProfilePage = () => resetPageFilters();

export const initProfilePage = ({ ...config }: {
  skipNextUpdate: boolean,
  profileType: string,
  isConsumerOverview: boolean,
  headerData: any,
  query: any,
}) => async (dispatch, getState) => {
  const {
    skipNextUpdate,
    profileType,
    isConsumerOverview,
    headerData,
   } = config;
  const state = getState();
  const { router: { location: { pathname } } } = state;

  const {
    ...changedProducts
  } = getValidChangedProducts(state, {
    productsCollection: headerData.products,
    regionsCollection: headerData.regions,
  });

  if (isRedirectToDefaultActive({ dispatch, ...changedProducts })) return;

  const filters = getBaseProfileFilters({ dispatch, changedProducts, state, ...config });

  if (!filters) return;

  if (skipNextUpdate) reInitProfilePage(dispatch);

  dispatch(setPageFilters(filters));

  dispatch(setMetaTags(getMetaTagsByFilters({
    isConsumerOverview,
    profileType,
    industry: filters.industry,
    sector: filters.sector,
    pathname,
  })));

  try {
    dispatch(getDealsTile());
  } catch (e) {
    AlertManager.error(getErrorMessage(e));
  }
};
